
import Vue, { PropType } from 'vue'
import Plant from '@/models/Plant'
import Avatar from '@/models/Avatar'

export default Vue.extend({
  props: {
    value: Object as PropType<Plant>,
    clickable: Boolean,
    size: {
      type: [Number, String],
      default: 40,
    },
  },
  data: () => ({
    dialog: false,

    error: undefined as Error | undefined,
    largeError: undefined as Error | undefined,
  }),
  computed: {
    plant(): Plant {
      return this.value
    },
    src(): string | undefined {
      const size = Number(this.size)
      const abbr = (
        Avatar.sizes.find((s) => size <= s.size) || { abbr: 'orig' }
      ).abbr
      return this.plant.avatar?.url[abbr]
    },
  },
  methods: {
    onClick(): void {
      if (this.clickable && this.plant && this.plant.hasAvatar)
        this.dialog = !this.dialog
    },
    onError(e: Error): void {
      this.error = e
    },
    onErrorLarge(e: Error): void {
      this.largeError = e
    },
  },
})
